/* @generated */

// src/assets/ui-icon/external-logo/chrome.tsx
import * as React from "react";
var ChromeExternalLogo = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12.037 20a8 8 0 0 0 7.366-11.037h-4.261a4.233 4.233 0 0 1 1.018 2.76 4.23 4.23 0 0 1-.626 2.221L12.037 20Zm-1.639-.16a8.003 8.003 0 0 1-6.157-9.795l4.431 4.431a4.24 4.24 0 0 0 3.997 1.429l-2.271 3.935ZM4.809 8.491l2.866 2.867a4.25 4.25 0 0 1 4.235-3.885v-.01h6.68A8 8 0 0 0 4.809 8.491Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "m14.249 13.17.001-.002a2.75 2.75 0 1 0-4.47.295l.311.31-.006.007a2.748 2.748 0 0 0 4.164-.61Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  ChromeExternalLogo
};
